
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { CategoryModel } from '@/models/category.model';
import { i18nModule } from '@/utils/store-acessor';
import { LocaleSelectorType } from '@/store/i18n.store.module';
import { getCategories } from '@/models/category.model';
import CategoryCard from '@/components/Shared/CategoryCard.vue';
import { Watch } from 'vue-property-decorator';

@Component({
  components: { CategoryCard }
})
export default class CategoriesList extends Vue {
  @i18nModule.Getter('locale') selected!: LocaleSelectorType;

  @Prop({ required: true })
  categories!: CategoryModel[];
  onuCategories!: any[];

  @Prop({ required: false, default: 0 })
  value!: number;

  created() {
    if (this.selected.value === 'en') {
      this.onuCategories = getCategories('en');
    } else {
      this.onuCategories = getCategories('br');
    }
  }

  @Watch('selected')
  onLocaleSelected(v: LocaleSelectorType) {
    if (v.value === 'en') {
      this.onuCategories = getCategories('en');
    } else {
      this.onuCategories = getCategories('br');
    }
  }

  openCategory(slug: string, id: number) {
    if (id === 18) {
      window.open('https://sustainabledevelopment.un.org/?menu=1300', '_blank');
    } else {
      this.$router.push(`/categories/${slug}`);
    }
  }

  get largeScreen() {
    return this.$vuetify.breakpoint.mdAndUp ? 'large-size' : 'small-size';
  }

  @Emit()
  onChange(path: string) {
    return path.replace('/categories/', '');
  }
}
